export default __webpack_public_path__ + "static/media/new_project.b702827f.svg";